import { useEffect, useMemo, useState } from "react";
import { IsNullOrEmpty } from "../../core/utility";
import { post } from "../../core/client";
import { useLocation } from "react-router-dom";
import { COMM_TYPES } from "../../core/consts";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Alert from "@mui/material/Alert";
import Input from "../../components/inputs/text-field-input";
import { CustomButton } from "../../components/buttons";
import { Chat, Email, TaskAlt } from "@mui/icons-material";
import { ResponseWithSuccess } from "../../core/client/Models";

interface StateModel {
    subscriber: string;
    type: string;
    reason: number | null;
    reasonOther: string;
    checkKocAilem: boolean;
    checkKocAilemMarket: boolean;
    checkOutboundPerm: boolean;
    checkKocailemCocuk :boolean;
    isUnderAge:boolean;
}

const useQuery = () => {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
}

const Subscribe = () => {

    //const classes = useStyles();

    let query = useQuery();
    const encriptedText = query.get('subs');

    const initialState: StateModel = {
        subscriber: "",
        type: "",
        reason: null,
        reasonOther: "",
        checkKocAilem: false,
        checkKocAilemMarket: false,
        checkKocailemCocuk:false,
        checkOutboundPerm: false,
        isUnderAge :false
    };
    const [state, setState] = useState<StateModel>(initialState);
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [isSend, setIsSend] = useState<boolean>(false);

    useEffect(() => {
        if (!IsNullOrEmpty(encriptedText)) {
            loadMaskedSubscriber(encriptedText as string)
        }
    }, [encriptedText]);

    const loadMaskedSubscriber = async (encriptedText: string) => {
        const request = {
            text: encriptedText
        }
        const { data, fail, errorMessage } = await post<any>('api/membership/get-masked-subscriber', request);
        if (data) {
           
            setState(prev => ({
                ...prev,
                subscriber: data.subscriber,
                type: data.type,
                isUnderAge:data.isUnderAge
            }));
        }
    }

    const handleChange = (e: any) => {
        setState(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    }

    const handleCheckbox = (e: any) => {
        setState(prev => ({
            ...prev,
            [e.target.name]: e.target.checked
        }));
    }

    const handleSend = async (model: StateModel) => {

        if (!validate(model)) return;

        setLoading(true);
        const request = {
            subscriber: encriptedText,
            subscribeKocAilem: model.checkKocAilem,
            subscribeKocAilemMarket: model.checkKocAilemMarket,
            subscribeOutbound: model.checkOutboundPerm,
            subscribeKocailemCocuk :model.checkKocailemCocuk
        }
        const { data, fail, errorMessage } = await post<ResponseWithSuccess>('api/membership/subscribe', request);
        if (data && data.success) {
            //success
            setIsSend(true);
        }
        setLoading(false);
    }

    const validate = (model: StateModel) => {
        setErrorMessage("");
        let isValid = true;

        if (!model.checkKocAilem && !model.checkKocAilemMarket && !model.checkOutboundPerm&&!model.checkKocailemCocuk) {
            setErrorMessage("Lütfen kayıt olacağınız üyeliği seçiniz.");
            isValid = false;
        }

        return isValid;
    }

    return (
        <Grid container spacing={2}>
            <Grid item sm={6}>
                <aside>
                    <div className="text">
                        <p className="head">KoçAilem'in ayrıcalıklı dünyasına hoş geldin,</p>
                        <p>KoçAilemlilere özel avantaj ve etkinliklerden haberdar olmak için hemen kayıt ol, kampanyalar telefonuna, epostana gelsin. Soruların ve detaylı bilgi için tüm KoçAilem kanallarından bize ulaşabilirsin.</p>
                        <p>Eğer KoçAilem’liysen;</p>
                        <p>Dilediğin menüyü seçer, en iyi restoranlarda yeni tatlar keşfeder ve indirimlerin tadını çıkarırsın. KoçAilem’le mobilde de otomobilde de avantajlısın. Dilediğin şehirde, istediğin aracı sana özel fiyatlara kiralar, depoyu doldurur, indirimli ödersin. KoçAilem’liysen buzdolabın da gardırobun da doludur. Vitrinde beğendiklerini gönlünce alır, market alışverişlerinde sakınmadan harcarsın. KoçAilem’le hayal ettiğin tatil senindir!</p>
                    </div>
                </aside>
            </Grid>
            <Grid item sm={6}>
                <aside>
                    <div className="form">
                        {!isSend ? (
                            <>
                                {state.type === COMM_TYPES.EMAIL && <div className="icon"><Email /></div>}
                                {state.type === COMM_TYPES.PHONE && <div className="icon"><Chat /></div>}
                                <Input
                                    id="subscriber"
                                    name="subscriber"
                                    caption=""
                                    className="mb-2"
                                    onChange={handleChange}
                                    value={state.subscriber}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={state.checkKocAilem} onChange={handleCheckbox} name="checkKocAilem" color="primary" />}
                                    label={`KoçAilem ${state.type === COMM_TYPES.EMAIL ? "e-posta" : "SMS"} üyeliğine kayıt ol.`}
                                />
                                <FormControlLabel
                                    control={<Checkbox checked={state.checkKocAilemMarket} onChange={handleCheckbox} name="checkKocAilemMarket" color="primary" />}
                                    label={`KoçAilem Market ${state.type === COMM_TYPES.EMAIL ? "e-posta" : "SMS"} üyeliğine kayıt ol.`}
                                />
                                 {!state.isUnderAge &&<FormControlLabel
                                    control={<Checkbox checked={state.checkKocailemCocuk} onChange={handleCheckbox} name="checkKocailemCocuk" color="primary" />}
                                    label={`KoçAilem Çocuk ${state.type === COMM_TYPES.EMAIL ? "e-posta" : "SMS"} üyeliğine kayıt ol.`}
                                />}
                                {state.type === COMM_TYPES.PHONE && (
                                    <FormControlLabel
                                        control={<Checkbox checked={state.checkOutboundPerm} onChange={handleCheckbox} name="checkOutboundPerm" color="primary" />}
                                        label={`KoçAilem arama izni ver.`}
                                    />
                                )}
                                {!IsNullOrEmpty(errorMessage) && (
                                    <Alert severity="error" className="mb-2">{errorMessage}</Alert>
                                )}
                                <CustomButton
                                    text="Gönder"
                                    className="btn-primary mt-2"
                                    fullWidth
                                    disabled={loading}
                                    loading={loading}
                                    onClick={() => handleSend(state)} />
                            </>
                        ) : (
                            <div className="success-container">
                                <TaskAlt className='success-icon' color='success' />
                                <p>Kayıt talebiniz alınmıştır.</p>
                            </div>
                        )}
                    </div>
                </aside>
            </Grid>
        </Grid >
    )
}

export default Subscribe;